<template>
  <v-container grid-list-md class="pa-0">
    <v-layout row wrap>
      <v-flex>
        <rate-type-list-select
          :rate-type-code="rateTypeCode"
          @onSelect="onRateTypeSelect"
          :outlined="outlinedInputs"
          hide-not-in-use
        ></rate-type-list-select>
      </v-flex>
    </v-layout>

    <h5 class="title">Cost {{ selectedRateTypeName }}</h5>
    <v-layout row wrap>
      <v-flex xs2>
        <v-text-field
          :disabled="isPerPerson || isExternalAndNotEditable"
          name="Item Cost"
          label="Item Cost"
          type="number"
          v-model.number="itemBuy"
          @change="onCostChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :disabled="!isPerPerson || isExternalAndNotEditable"
          name="Adult Cost"
          type="number"
          label="Adult"
          v-model.number="adultBuy"
          @change="onCostChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson || isExternalAndNotEditable"
          name="Child Cost"
          type="number"
          label="Child Cost"
          v-model.number="childBuy"
          @change="onCostChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson || isExternalAndNotEditable"
          name="Infant Cost"
          type="number"
          label="Infant Cost"
          v-model.number="infantBuy"
          @change="onCostChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <currency-list-select
          :currency-code="currencyBuy"
          :include-exchange-rate="true"
          v-model="currencyBuy"
          @onSelect="onBuyCurrencySelect"
          :outlined="outlinedInputs"
          hide-details
          :enabled="!isExtra && !isExternalAndNotEditable"
        ></currency-list-select>
      </v-flex>
    </v-layout>
    <v-row align="end">
      <v-col sm="5">
        <h5 class="title">Sell {{ selectedRateTypeName }}</h5>
      </v-col>
      <v-col sm="3">
        <v-switch
          v-model="autoSell"
          @change="onAutoSellChange"
          label="Update Sell"
        />
      </v-col>
      <v-col sm="4" class="pl-0">
        <v-text-field
          label="Markup %"
          v-model.number="markup"
          :outlined="outlinedInputs"
          @change="onMarkupChange"
          :hide-details="markupLookupMsg == ''"
          :messages="markupLookupMsg"
          :loading="markupLookupLoading"
        >
          <template v-slot:append-outer v-if="markupLookupEnabled">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="lookupMarkup">
                  mdi-table-search
                </v-icon>
              </template>
              <span>Lookup markup % from the markup table</span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-layout row wrap v-if="isISCVisible">
      <v-flex xs2>
        <v-text-field
          :disabled="isPerPerson"
          name="Item Sell"
          type="number"
          label="Item Sell"
          v-model.number="itemSellISC"
          @change="onISCChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :disabled="!isPerPerson"
          name="Adult Sell"
          type="number"
          label="Adult Sell"
          v-model.number="adultSellISC"
          @change="onISCChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson"
          name="Child Sell"
          type="number"
          label="Child Sell"
          v-model.number="childSellISC"
          @change="onISCChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson"
          name="Infant Sell"
          type="number"
          label="Infant Sell"
          v-model.number="infantSellISC"
          @change="onISCChange"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <currency-list-select
          :currency-code="currencyBuy"
          v-model="currencyBuy"
          :outlined="outlinedInputs"
          :enabled="false"
          hide-details
        ></currency-list-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs2>
        <v-text-field
          :disabled="isPerPerson"
          name="Item Sell"
          type="number"
          label="Item Sell"
          v-model="itemSell"
          @change="onChangeListener"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :disabled="!isPerPerson"
          name="Adult Sell"
          type="number"
          label="Adult Sell"
          v-model="adultSell"
          @change="onChangeListener"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson"
          name="Child Sell"
          type="number"
          label="Child Sell"
          v-model="childSell"
          @change="onChangeListener"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs2 v-if="!hideChildren">
        <v-text-field
          :disabled="!isPerPerson"
          name="Infant Sell"
          type="number"
          label="Infant Sell"
          v-model.number="infantSell"
          @change="onChangeListener"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <currency-list-select
          :currency-code="currencySell"
          v-model="currencySell"
          :enabled="false"
          :include-exchange-rate="true"
          @onSelect="onSellCurrencySelect($event)"
          :outlined="outlinedInputs"
        ></currency-list-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-checkbox
          label="Custom Price"
          v-model="customPricing"
          :disabled="true"
        ></v-checkbox>
      </v-flex>
      <v-flex class="text-right">
        <strong>Total Buy:</strong>
        {{ totalBuy | priceLabeler }}
        <strong>Base:</strong>
        {{ totalBuyBase | priceLabeler }}
        <strong>Total Sell:</strong>
        {{ totalSell | priceLabeler }}
        <strong>Base:</strong>
        {{ totalSellBase | priceLabeler }}
      </v-flex>
    </v-layout>
    <v-row v-if="showDiscountInfo">
      <v-col>
        <v-alert type="info">
          {{ discountsInfo }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="showCompsInfo">
      <v-col>
        <v-alert type="info">
          {{ compsInfo }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="isPercentPriceExtra">
      <v-col>
        <v-alert type="warning"
          >Price is {{ extraPercent }}% of parent service. % extra prices cannot
          be changed.</v-alert
        >
      </v-col>
    </v-row>
    <div v-if="debug">
      <code>{{ markupLookupEnabled }}</code>
    </div>
  </v-container>
</template>

<script>
import RateTypeListSelect from "../../../shared/RateTypeListSelect";
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import { durationInDays } from "@/helpers";
import {
  ALL_CURRENCIES_SEARCH_QUERY,
  ALL_EXCHANGE_RATES_SEARCH_QUERY,
  ALL_RATE_TYPES_SEARCH_QUERY,
} from "../../../../../constants/graphql";
import gql from "graphql-tag";
const SERVICE_INFO = gql`
  query serviceInfo($id: ID!) {
    service(id: $id) {
      id
      extrasChildPrice
    }
  }
`;
//11058 - markup table lookup for custom priced services
const SERVICE_MARKUP_QUERY = gql`
  query serviceMarkup(
    $serviceId: ID!
    $date: DateTimeType!
    $agentId: ID
    $department: String
    $itineraryCreationDate: DateTimeType
  ) {
    serviceMarkup(
      serviceId: $serviceId
      date: $date
      agentId: $agentId
      department: $department
      itineraryCreationDate: $itineraryCreationDate
    )
  }
`;
const moment = require("moment");
export default {
  name: "ItemPricingForm",

  props: {
    selectedItem: { type: Object, default: () => null },
    headerProps: { type: Object, default: () => ({}) },
  },

  components: {
    RateTypeListSelect,
    CurrencyListSelect,
  },

  data() {
    return {
      debug: false,
      rateTypeCode:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.rateTypeCode
          : "",
      itemBuy:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.itemBuy
          : 0,
      //InSupplier'sCurrency - ISC
      itemSellISC:
        this.selectedItem && this.selectedItem.pricing
          ? this.inSupplierCurrency("item", this.selectedItem)
          : 0,
      itemSell:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.itemSell
          : 0,

      adultBuy:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.adultBuy
          : 0,
      childBuy:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.childBuy
          : 0,
      infantBuy:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.infantBuy
          : 0,

      adultSell:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.adultSell
          : 0,
      adultSellISC:
        this.selectedItem && this.selectedItem.pricing
          ? this.inSupplierCurrency("adult", this.selectedItem)
          : 0,
      childSell:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.childSell
          : 0,
      childSellISC:
        this.selectedItem && this.selectedItem.pricing
          ? this.inSupplierCurrency("child", this.selectedItem)
          : 0,
      infantSell:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.infantSell
          : 0,
      infantSellISC:
        this.selectedItem && this.selectedItem.pricing
          ? this.inSupplierCurrency("infant", this.selectedItem)
          : 0,

      currencyBuy:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.currencyBuy
          : "",
      currencySell:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.currencySell
          : "",
      currencyBuyExRate:
        this.selectedItem && this.selectedItem.pricing
          ? this.selectedItem.pricing.currencyBuyExchangeRate
          : 1,
      currencySellExRate:
        this.selectedItem && this.selectedItem.pricing.currencySellExchangeRate
          ? this.selectedItem.pricing.currencySellExchangeRate
          : 1,
      rateType: null,
      customPricing: this.selectedItem.customPricing,
      markup: 0,
      markupLookupLoading: false,
      markupLookupMsg: "",
      autoSell: this.$store.getters.localSettings(
        "pricingEditorAutoSell",
        true
      ),
    };
  },

  methods: {
    onAutoSellChange() {
      this.$store.dispatch("updateLocalSettings", {
        pricingEditorAutoSell: this.autoSell,
      });
    },
    toAgentCurrency(amount) {
      // console.log(
      //   "to agent currency: ",
      //   amount,
      //   this.currencyBuy,
      //   this.itineraryAgentCurrencyExRate
      // );
      return (
        (amount / Number(this.currencyBuyExRate)) *
        Number(this.itineraryAgentCurrencyExRate)
      ).toFixed(2);
    },
    applyMarkup(f, markup) {
      const newPrice =
        Number(this[f]) + Number(this[f]) * (Number(markup) / 100);
      //console.log(Number(markup), newPrice);
      return newPrice.toFixed(2);
    },
    onMarkupChange() {
      if (this.autoSell) {
        if (this.isPerPerson) {
          for (const paxType of ["adult", "child", "infant"]) {
            const f = `${paxType}SellISC`;
            this[f] = this.applyMarkup(`${paxType}Buy`, this.markup);
          }
        } else {
          this.itemSellISC = this.applyMarkup("itemBuy", this.markup);
        }

        this.updateSellPrices();
      }
      this.emitChange();
    },
    updateSellPrices() {
      if (this.isPerPerson) {
        for (const paxType of ["adult", "child", "infant"]) {
          const f = `${paxType}SellISC`;
          this[`${paxType}Sell`] = this.toAgentCurrency(this[f]);
        }
      } else {
        this.itemSell = this.toAgentCurrency(Number(this.itemSellISC));
      }
    },
    //11058 - lookup markup % from the markup table rules
    lookupMarkup() {
      this.markupLookupMsg = "";
      this.markupLookupLoading = true;
      this.$apollo
        .query({
          query: SERVICE_MARKUP_QUERY,
          fetchPolicy: "network-only",
          variables: {
            serviceId: this.selectedItem.serviceId,
            date: this.selectedItem.startDate,
            agentId: this.headerProps.agentId || null,
            department: this.headerProps.departmentName || null,
            itineraryCreationDate: this.headerProps.createdAt || null,
          },
        })
        .then(({ data }) => {
          this.markupLookupLoading = false;
          if (data.serviceMarkup != null) {
            this.markup = data.serviceMarkup;
            this.onMarkupChange();
          } else {
            this.markupLookupMsg = "No markup rule found";
          }
        })
        .catch(() => {
          this.markupLookupLoading = false;
          this.markupLookupMsg = "Markup lookup failed";
        });
    },
    onRateTypeSelect($event) {
      this.rateType = $event;
      this.rateTypeCode = $event.code;
      this.resetInputs();

      if (this.propChanged("rateTypeCode")) {
        this.emitChange();
      }
    },
    resetInputs() {
      if (this.isPerPerson) {
        this.itemBuy = "";
        this.itemSell = "";
        this.itemSellISC = "";
        if (this.selectedItem && this.selectedItem.pricing) {
          for (const paxType of ["adult", "child", "infant"]) {
            for (const priceType of ["Buy", "Sell"]) {
              const fieldName = paxType + priceType;
              this[fieldName] = this.selectedItem.pricing[fieldName];
            }
          }
        }
      } else {
        for (const paxType of ["adult", "child", "infant"]) {
          for (const priceType of ["Buy", "Sell", "SellISC"]) {
            const fieldName = paxType + priceType;
            this[fieldName] = "";
          }
        }
        if (this.selectedItem && this.selectedItem.pricing) {
          this.itemBuy = this.selectedItem.pricing["itemBuy"];
          this.itemSell = this.selectedItem.pricing["itemSell"];
        }
      }
      this.updateISC();
    },
    onSellCurrencySelect($event) {
      //it's blocked now anyway
      // this.currencySell = $event.code;
      // this.currencySellExRate = $event.exchangeRate;
      // if (this.propChanged("currencySell")) {
      //   this.emitChange();
      // }
    },
    onBuyCurrencySelect($event) {
      if (!this.isExtra) {
        // to keep custom fx
        if (this.currencyBuy != $event.code) {
          this.currencyBuy = $event.code;
          this.currencyBuyExRate = $event.exchangeRate;
          this.updateSellPrices();
          this.emitChange();
        }
      } //what about extras?
    },
    onISCChange() {
      this.updateMarkup();

      this.updateSellPrices();

      this.emitChange();
    },
    onCostChange() {
      this.onMarkupChange();
    },
    onChangeListener($event) {
      this.updateISC();
      this.emitChange();
    },
    propChanged(propName) {
      if (this.selectedItem) {
        return this.selectedItem.pricing[propName] != this[propName];
      }
      return false;
    },
    emitChange() {
      //this.customPricing = true;
      let pricing = {
        customPricing: this.customPricing,
        ...this.selectedItem.pricing,
      };
      for (let key in pricing) {
        if (this.hasOwnProperty(key)) {
          if (
            (key.indexOf("Buy") != -1 || key.indexOf("Sell") != -1) &&
            key.indexOf("currency") == -1
          ) {
            pricing[key] = Number(this[key]);
          } else {
            pricing[key] = this[key];
          }
          //console.log(`${key} : ${this[key]}`);

          //http://tracker.globetrack.ie/issues/5614
        } else if (key == "currencyBuyExchangeRate") {
          pricing.currencyBuyExchangeRate = Number(this.currencyBuyExRate);
        }
      }
      //console.log("change", pricing);
      //for new items
      this.$emit("onChange", {
        pricing,
        totalPrice: this.totalSell,
      });
    },
    //going functional :)
    getTotalFunction(type) {
      const totalFunction = () => {
        let total = 0;
        //console.log("total function selectedItem", this.selectedItem);
        //console.log("total function isPerPerson", this.isPerPerson);
        if (this.selectedItem) {
          if (this.isPerPerson) {
            const comp = type == "Buy" ? this.supplierComp : this.passComp;
            const adults = Number(this.selectedItem.adults) - comp;
            const perAdult = adults * Number(this[`adult${type}`]);
            const perChild =
              Number(this.selectedItem.children) * Number(this[`child${type}`]);
            const perInfant =
              Number(this.selectedItem.infants) * Number(this[`infant${type}`]);
            total = perAdult + perChild + perInfant;
          } else {
            total = Number(this.selectedItem.qty) * Number(this[`item${type}`]);
          }

          if (this.rateType && this.rateType.includeDays) {
            let duration = Number(
              durationInDays(
                this.selectedItem.startDate,
                this.selectedItem.endDate
              )
            );
            //console.log("duration = ", duration);
            if (
              (["ACCOMMODATION"].indexOf(this.selectedItem.serviceType) == -1 ||
                this.selectedItem.isExtra) &&
              duration > 0
            ) {
              duration++;
            }
            if (duration == 0) {
              duration = 1;
            }

            //https://tracker.globetrack.ie/issues/8724
            if (
              duration > 1 &&
              this.selectedItem.serviceType == "TRANSPORT" &&
              this.selectedItem.remarks &&
              this.selectedItem.remarks.pickupTime &&
              this.selectedItem.remarks.pickupTime != "" &&
              this.selectedItem.remarks.dropoffTime &&
              this.selectedItem.remarks.dropoffTime != ""
            ) {
              //console.log("duration", duration, this.selectedItem.remarks);
              const start = parseInt(
                this.selectedItem.remarks.pickupTime.replace(":", "")
              );
              const end = parseInt(
                this.selectedItem.remarks.dropoffTime.replace(":", "")
              );
              //console.log("start", start, "end", end);
              if (end <= start) {
                duration--;
              }
            }
            //onsole.log("duration =>", duration);
            total = total * duration;
          }
        }

        const circuitDiscount =
          this.selectedItem && this.selectedItem.pricing
            ? this.selectedItem.pricing[
                `circuitDiscount${type == "Buy" ? "Cost" : "Sell"}`
              ]
            : 0;
        const regularDiscount =
          this.selectedItem &&
          this.selectedItem.pricing &&
          this.selectedItem.pricing[
            `discount${type == "Buy" ? "Cost" : "Sell"}`
          ]
            ? this.selectedItem.pricing[
                `discount${type == "Buy" ? "Cost" : "Sell"}`
              ]
            : 0;
        const discount =
          circuitDiscount > 0 ? circuitDiscount : regularDiscount;
        return total; // - discount;
      };
      return totalFunction;
    },
    inSupplierCurrency(field, item) {
      if (this.currencyBuy == this.currencySell) {
        return this[`${field}Sell`];
      }
      if (item && item.pricing.currencyBuy == item.pricing.currencySell) {
        return item.pricing[`${field}Sell`];
      }
      return item
        ? (
            (item.pricing[`${field}Sell`] /
              Number(item.pricing.currencySellExchangeRate)) *
            Number(item.pricing.currencyBuyExchangeRate)
          ).toFixed(2)
        : (
            (this[`${field}Sell`] / Number(this.currencySellExRate)) *
            Number(this.currencyBuyExRate)
          ).toFixed(2);
    },
    updateISC() {
      if (this.isPerPerson) {
        for (const paxType of ["adult", "child", "infant"]) {
          this[`${paxType}SellISC`] = this.inSupplierCurrency(paxType);
        }
      } else {
        this.itemSellISC = this.inSupplierCurrency("item");
      }
      this.updateMarkup();
    },
    updateMarkup() {
      let markup;
      if (this.isPerPerson) {
        let sellPrice, buyPrice;
        if (Number(this.adultBuy) > 0) {
          sellPrice = Number(this.adultSellISC);
          buyPrice = Number(this.adultBuy);
        } else if (Number(this.childBuy) > 0) {
          sellPrice = Number(this.childSellISC);
          buyPrice = Number(this.childBuy);
        } else if (Number(this.infantBuy) > 0) {
          sellPrice = Number(this.infantSellISC);
          buyPrice = Number(this.infantBuy);
        }

        markup = (((sellPrice - buyPrice) / buyPrice) * 100).toFixed(2);
      } else {
        markup = (
          ((Number(this.itemSellISC) - Number(this.itemBuy)) /
            Number(this.itemBuy)) *
          100
        ).toFixed(2);
      }
      if (isFinite(markup)) {
        this.markup = markup;
      } else {
        this.markup = 0;
      }
    },
  },

  watch: {
    selectedItem(value) {
      for (let key in value.pricing) {
        if (this.hasOwnProperty(key)) {
          this[key] = value.pricing[key];
        }
      }
      this.customPricing = value.customPricing;
      this.currencyBuyExRate = value.pricing.currencyBuyExchangeRate;
      this.currencySellExRate = value.pricing.currencySellExchangeRate;

      this.resetInputs();
      this.updateISC();
    },
  },

  computed: {
    //11058 - markup table lookup available for custom priced services
    markupLookupEnabled() {
      return (
        this.$store.getters.hasAccessTo("itineraries:markup_lookup") &&
        this.selectedItem &&
        this.selectedItem.serviceId != "" &&
        this.selectedItem.serviceId != null
      );
    },
    isExternalAndNotEditable() {
      return (
        this.selectedItem &&
        this.selectedItem.isExternal &&
        !this.resRequestEditCostPrice
      );
    },
    resRequestEditCostPrice() {
      const isResRequestItem =
        this.selectedItem &&
        this.selectedItem.source &&
        this.selectedItem.source.name == "RESREQUEST";
      return (
        isResRequestItem &&
        this.$store.getters.hasAccessTo(
          "third_party:resrequest_edit_cost_price"
        )
      );
    },
    supplierComp() {
      return this.selectedItem ? Number(this.selectedItem.supplierComp) : 0;
    },
    passComp() {
      return this.selectedItem ? Number(this.selectedItem.passComp) : 0;
    },
    hideChildren() {
      return this.service && this.service.extrasChildPrice && !this.isExtra;
    },
    selectedRateTypeName() {
      const selected =
        this.rateTypes && this.rateTypes.edges
          ? this.rateTypes.edges.find(
              (item) => item.node.code == this.rateTypeCode
            )
          : false;
      return selected ? selected.node.name : "";
    },
    isExtra() {
      return this.selectedItem && this.selectedItem.isExtra;
    },
    isPercentPriceExtra() {
      if (this.isExtra) {
        const extra = this.selectedItem.extras.find(
          (e) => e.id == this.selectedItem.extraId
        );
        return extra && Number(extra.percentPrice) > 0;
      } else {
        return false;
      }
    },
    extraPercent() {
      if (this.isExtra) {
        const extra = this.selectedItem.extras.find(
          (e) => e.id == this.selectedItem.extraId
        );
        return Number(extra.percentPrice);
      } else {
        return 0;
      }
    },
    showDiscountInfo() {
      return (
        this.selectedItem &&
        this.selectedItem.pricing &&
        (this.selectedItem.pricing.discountSell > 0 ||
          this.selectedItem.pricing.circuitDiscountSell > 0 ||
          this.selectedItem.pricing.discountCost > 0 ||
          this.selectedItem.pricing.circuitDiscountCost > 0)
      );
    },
    discountsInfo() {
      const pricing = this.selectedItem.pricing
        ? this.selectedItem.pricing
        : { discountPercent: 0, discountCost: 0, discountSell: 0 };
      const dc =
        pricing.circuitDiscountCost > 0
          ? pricing.circuitDiscountCost
          : pricing.discountCost;
      const ds =
        pricing.circuitDiscountSell > 0
          ? pricing.circuitDiscountSell
          : pricing.discountSell;
      const desc = pricing.discountDescription
        ? `Discount applied: ${pricing.discountDescription}`
        : pricing.discountInfo
        ? `Discount applied: ${pricing.discountInfo}`
        : "";
      return `${desc} Total discount: Cost ${dc}, Sell ${ds}`;
    },
    showCompsInfo() {
      return (
        (this.selectedItem && this.selectedItem.supplierComp > 0) ||
        this.selectedItem.passComp > 0
      );
    },
    compsInfo() {
      return `Total Comp: Cost ${this.selectedItem.supplierComp}, Sell ${this.selectedItem.passComp}`;
    },
    isISCVisible() {
      return this.currencyBuy != this.itineraryAgentCurrency;
    },
    itineraryAgentCurrencyExRate() {
      // const exRate = this.exchangeRates
      //   ? this.exchangeRates.edges.find(
      //       (item) =>
      //         item.node.currencyCode == this.itineraryAgentCurrency &&
      //         moment().isBetween(
      //           moment(item.node.dateFrom),
      //           moment(item.node.dateTo),
      //           []
      //         )
      //     )
      //   : null;
      //return exRate ? exRate.node.rate : 1;
      if (
        this.selectedItem &&
        this.selectedItem.pricing.currencySell == this.itineraryAgentCurrency
      ) {
        return this.selectedItem.pricing.currencySellExchangeRate;
      }
      const currency = this.currencies
        ? this.currencies.edges.find(
            (item) => item.node.code == this.itineraryAgentCurrency
          )
        : null;
      const exRate = currency ? currency.node.exchangeRate : 1;
      return exRate;
    },
    itineraryAgentCurrency() {
      return this.$store.getters.itineraryAgentCurrency;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isPerPerson() {
      return this.rateType && this.rateTypeCode
        ? this.rateType.includePax
        : this.selectedItem && !this.selectedItem.pricing.itemBased;
    },
    totalBuy() {
      //console.log(this.getTotalFunction("Buy")());
      return this.getTotalFunction("Buy")().toFixed(2);
    },
    totalBuyBase() {
      return (
        this.getTotalFunction("Buy")() / Number(this.currencyBuyExRate)
      ).toFixed(2);
    },
    totalSell() {
      return this.getTotalFunction("Sell")();
    },
    totalSellBase() {
      return (
        this.getTotalFunction("Sell")() / Number(this.currencySellExRate)
      ).toFixed(2);
    },
  },

  apollo: {
    // exchangeRates: {
    //   query: ALL_EXCHANGE_RATES_SEARCH_QUERY,
    //   result({ data }) {
    //     this.updateISC();
    //   },
    // },

    service: {
      query: SERVICE_INFO,
      variables() {
        return { id: this.selectedItem.serviceId };
      },
      skip() {
        return !this.selectedItem || this.selectedItem.serviceId == "";
      },
    },

    currencies: {
      query: ALL_CURRENCIES_SEARCH_QUERY,
      variables() {
        return {
          includeExchangeRate: true,
        };
      },
      result({ data }) {
        this.updateISC();
      },
    },
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
    },
  },
};
</script>

<style></style>
``



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemPricingForm.vue